// extracted by mini-css-extract-plugin
export default {"back-icon":"WanSN_back-icon","nav-text":"d5YOO_nav-text","share-wrapper":"UFb3H_share-wrapper","share-icon":"NoqxA_share-icon"};